export default __webpack_public_path__ + "static/media/1.67b8ae37.png";